import { useCallback, useEffect, useState } from "react";
import "./components/Recon.css";
import Spinner from "../Spin/Spinner";
import HeaderTableRecon from "./components/HeaderTableRecon";
import ReconTable from "./components/ReconTable";
import { getAllUsers, getReconData } from "../../config/LiveApi";
import { useSelector } from "react-redux";

function ReconciliationTable() {
  let token = useSelector((store) => store.userReducer.token);
  const [dataItem, setDataItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const [pagesData, setPagesData] = useState(0);
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    return new Date(today.setHours(0, 0, 0, 0));
  });
  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    return new Date(today.setHours(23, 59, 59, 999));
  });
  const [currentPage, setCurrentPage] = useState(1);
  const role = useSelector((state) => state.userReducer.role);

  const getReconciliationData = async (
    token,
    currentPage,
    startDate = "",
    endDate = ""
  ) => {
    setLoading(true);

    try {
      const formattedStart = startDate
        ? startDate instanceof Date
          ? startDate.toISOString()
          : new Date(startDate).toISOString()
        : undefined;
      const formattedEnd = endDate
        ? endDate instanceof Date
          ? endDate.toISOString()
          : new Date(endDate).toISOString()
        : undefined;

      if (
        ![
          "admin",
          "super",
          "operation",
          "pros",
          "accounts",
          "subSuper",
          "subAdmin",
          "compliance",
        ].includes(role)
      ) {
        return;
      }
      const data = await getReconData(
        token,
        currentPage,
        formattedStart,
        formattedEnd
      );
      setDataItem(data.data);
      setPagesData(data.meta?.pagination?.totalPages);
    } catch (error) {
      console.error("Failed to fetch reconciliation data:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchUsers = useCallback(async () => {
    try {
      const response = await getAllUsers(token, currentPage);
      const data = response.data;

      setUserData(data);
    } catch (error) {
      console.log(error.message);
    }
  }, [token, currentPage]);
  useEffect(() => {
    if (
      role === "super" ||
      role === "operation" ||
      role === "compliance" ||
      role === "subSuper"
    )
      fetchUsers();
  }, [fetchUsers, role]);

  useEffect(() => {
    if (token) {
      getReconciliationData(token, currentPage, startDate, endDate);
    }
  }, [currentPage, endDate, startDate, token]);

  return (
    <div>
      <HeaderTableRecon
        setParentStartDate={setStartDate}
        setParentEndDate={setEndDate}
        currentPage={currentPage}
        getReconciliationData={getReconciliationData}
      />
      <div className="mar-top-rol">
        {dataItem &&
          dataItem.length > 0 && (
            <ReconTable
              dataItem={dataItem}
              userData={userData}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              pagesData={pagesData}
              startDate={startDate}
              endDate={endDate}
              getReconciliationData={getReconciliationData}
            />
          )
        }

        {dataItem && dataItem.length === 0 && (
          <div className="no-data">No Reconcilation Available</div>
        )}
      </div>
    </div>
  );
}

export default ReconciliationTable;
